<div class="container-fluid position-relative d-flex flex-column admin" (click)="closeSideBox()">

  <div class="d-flex flex-row py-4 align-items-center sticky-top bg-white ">
    <h1 class="fw-bold m-0">
      {{ totalWaitingRefund }}
      Demande{{ totalWaitingRefund > 1 ? 's' : '' }} de remboursement
      <mat-icon class="ms-2 me-4 pointer font-18" (click)="refresh('attestation')"> autorenew</mat-icon>
    </h1>
    <div class="d-flex flex-column">
      <div class="date-filters d-flex align-items-center gap-2">
        <mat-form-field class="date-field">
          <label>début</label>
          <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate" (dateChange)="onDateChange()">
          <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="date-field">
          <label>fin</label>
          <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate" (dateChange)="onDateChange()">
          <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <p *ngIf="startDate && endDate" class="minitext_1_bold d-flex justify-content-center text-align-end gap-3">{{typeDate}}<lf-icon name="question" width="18px" height="18px" class="pe-2 pointer" fillColor="#FFCD1D" [ngbPopover]="'Type de date sur laquel on filtre.'" [triggers]="'mouseenter:mouseleave'"></lf-icon></p>
    </div>

    <div class="d-flex flex-column gap-2 ms-2">
      <mat-icon class="search-icon" aria-hidden="false" aria-label="Example home icon" fontIcon="search" (click)="onDateChange()"></mat-icon>
      <mat-icon class="xmark-icon" aria-hidden="false" aria-label="Example home icon" fontIcon="clear" (click)="clearDates()"></mat-icon>
    </div>


    <div class="ms-auto">
      <div class="search_box d-flex align-items-center position-relative ">
        <mat-icon class="search-icon" aria-hidden="false" aria-label="Example home icon" fontIcon="search"></mat-icon>
        <input class="border-0 mediumGray" placeholder="Ex: exemple@gmail.com" [(ngModel)]="sellSearchText" (ngModelChange)="filterOnInput()">
      </div>
      <small class="text-grey-light fst-italic">Recherche sur le nom, le prénom ou l'email de l'étudiant</small>
    </div>

  </div>

  <div class="d-flex flex-row listing_box gap-24">
    <!------------------------- SELLS LISTING ------------------------->
    <div class="w-100 d-flex flex-column position-relative">
      <mat-tab-group #matTabGroup class="lf-font lf-tab far-border" animationDuration="0ms" (selectedTabChange)="changeDatas($event)">
        <mat-tab *ngFor="let tab of displayTab">
          <ng-template mat-tab-label>
            <span class="mediumGray" (click)="sort('date', 'desc')">{{ tab }}</span>
            <div class="sort-icons ms-2">
              <mat-icon class="pointer" [ngClass]="{'active': sortField === 'date' && sortOrder === 'asc'}"
                        (click)="sort('date', 'asc')">arrow_upward</mat-icon>
              <mat-icon class="pointer" [ngClass]="{'active': sortField === 'date' && sortOrder === 'desc'}"
                        (click)="sort('date', 'desc')">arrow_downward</mat-icon>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>

      <div class="mt-2 h-100 overflow-auto hidden-scrollbar" *ngIf="!isLoadingDatas && datas && !isLoadingMore">
        <!--    AFFICHAGE DES DATAS    -->
        <div class="py-3 px-4 d-flex flex-row gap-16 transition05" *ngFor="let item of datas['datas']" (click)="$event.stopPropagation();openSideBox(item)"
          [ngClass]="{'selected': sideBoxItem && sideBoxItem.id === item.id}">
          <img class="br-6 img-cover" checkurl [src]="getAvatar(item.user)" alt="">
          <div class="d-flex flex-column w-35">
            <div class="d-flex flex-row align-items-end mb-1">
              <h1 class="fw-bold m-0 font-18">
                {{ item.user && item.user['lastname'] ? item.user['lastname'] : 'Inconnu' }}
                {{ item.user && item.user['firstname'] ? item.user['firstname'] : 'Inconnu' }}
              </h1>
              <span class="font-14 ms-1 lightGray2" *ngIf="item['user_id']">#{{item['user_id']}}</span>
            </div>
            <a href="mailto:{{item.user.email}}" class="font-12 mediumGray w-fit-content" *ngIf="item.user && item.user.email" (click)="$event.stopPropagation()">
              {{ item.user.email}}
            </a>
            <span class="font-12 mediumGray">{{ item.user && item.user.phone ? item.user.phone : '' }}</span>


            <img class="pointer" (click)="$event.stopPropagation();getPayoutPaymentLink(item.id)"
                 matTooltip="Aller sur la page de paiement"
                  ngSrc="/assets/img/admin/picto/{{item['transaction_mode'] ? item['transaction_mode'] : 'stripe'}}.png"
                 height="40" width="40" alt="Icône de transaction : {{item['transaction_mode'] ? item['transaction_mode'] : 'stripe'}}"/>
          </div>
          <div class="w-25 border-right border-left d-flex flex-column align-items-center justify-content-center font-10 lightGray gap-1">
            <div>
              <strong class="text-primary font-12">
                {{ item.user && item.user['faculty'] && item.user['faculty']['city'] ? item.user['faculty']['city'] : 'Inconnu' }}
              </strong>
              |
              <span>{{ item.total ? item.total : 'NA' }}€</span>
            </div>
            <div class="minitext_1">
              Achetée le {{item.created_at | date:'shortDate':'':'FR'}}
            </div>
            <div class="minitext_1">
              Référence: {{item.reference ? item.reference: 'Pas de référence'}}
            </div>
            <span class="text-primary font-12" [ngClass]="calculateStatus(item.created_at).class">
              {{ calculateStatus(item.created_at).text }} - {{ calculateStatus(item.created_at).time }}
            </span>
            <div *ngIf="item.status == 'Pending-refund'">
              <span class="minitext_1" *ngIf="item.refundDatas">Demande émise le : {{ getAskRefundDate(item.refundDatas)  | date:'shortDate':'':'FR' }}</span>
            </div>
            <div *ngIf="item.status == 'Refunded'">
              <span class="minitext_1" *ngIf="item.refundDatas">Remboursée le" : {{ getRefundedDate(item.refundDatas)  | date:'shortDate':'':'FR' }}</span>
            </div>
            <div *ngIf="item.status == 'Not-refunded'">
              <span class="minitext_1" *ngIf="item.refundDatas">Refusé le : {{ getRefusedDate(item.refundDatas)  | date:'shortDate':'':'FR' }}</span>
            </div>
          </div>
          <div class="w-25 d-flex align-items-center justify-content-center">
            <div class="status-pastille d-flex flex-row pe-1 text-uppercase font-14 pointer w-fit-content mx-auto align-items-center"
              [ngClass]="{'bg-warning': item.status !== 'Not-refunded' && item.status !== 'Canceled', 'bg-grad-yellow':item.status === 'Canceled', 'bg-grad-red':item.status === 'Not-refunded'}">
              Voir
              <mat-icon class="ms-2 bg-white fw-light">add</mat-icon>
            </div>
            <div class="col-2text-start">
              <div class="mb-1">
                <a target="_blank" rel="noopener noreferrer" height="28px" class="me-4" [ngClass]="{'disabled' : !item.user?.crmId}" href="https://app.hubspot.com/contacts/2665222/contact/{{item.user?.crmId}}">
                  <img alt="logo hubspot " src="/assets/img/admin/picto/logo_hub.png" style="width: 28px; height: 28px;"/>
                </a>
              </div>
              <div class="mb-1">
                <a target="_blank" rel="noopener noreferrer" [ngClass]="{'disabled' : !item.user?.phone}" [href]="getWhatsAppLink(item.user?.phone)">
                  <img alt="logo whatsapp pour le contact avec les étudiants" src="/assets/img/admin/picto/logo_whatsapp.png" style="width: 28px; height: 28px;"/>
                </a>
              </div>
              <div>
                <a target="_blank" rel="noopener noreferrer" href="/admin/users/{{item.user_id}}">
                  <img alt="logo pour accéder au profil des étudiants" class="pointer" src="/assets/img/admin/picto/logo1.png" style="width: 28px; height: 28px;"/>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!--   LOADER & NO DATAS  -->
      <div class="w-100 h-100 d-flex align-items-center justify-content-center my-5" *ngIf="isLoadingMore || isLoadingDatas">
        <div class="spinner-border text-primary"></div>
      </div>
      <!--   NO DATAS   -->
      <div class="w-100 h-100 d-flex align-items-center justify-content-center mb-5" *ngIf="!isLoadingDatas && (!datas || datas['datas'].length === 0) && !isLoadingMore">
        <span>Pas de données correspondantes.</span>
      </div>
      <!--   PAGINATION   -->
      <mat-paginator class="sticky-bottom bg-white py-2" [length]="datas.total" [pageSize]="20" hidePageSize="true" (page)="loadPage($event)" *ngIf="!isLoadingDatas && datas && datas['datas'].length > 0"></mat-paginator>
    </div>

  </div>

</div>

<!---------------------------------------- SIDE POP UP ------------------------------------------>
<div class="position-absolute d-flex flex-column bg-white br-24 p-4 lf-side_pop-up" *ngIf="isSideOpen && sideBoxItem" (click)="$event.stopPropagation(); isRefusalOpen = false;">
  <mat-icon class="font-16 pointer lightGray2 position-absolute right-0" (click)="closeSideBox()">clear</mat-icon>
  <div class="d-flex flex-row align-items-center">
    <img checkurl [src]="getAvatar(sideBoxItem.user)" alt="" class="br-24 profile-image me-3">
    <div class="d-flex flex-column ms-2 font-12">
      <h5 class="font-18 fw-bold mb-0">
        {{ sideBoxItem.user && sideBoxItem.user['lastname'] ? sideBoxItem.user['lastname'] : 'Inconnu' }}
        {{ sideBoxItem.user && sideBoxItem.user['firstname'] ? sideBoxItem.user['firstname'] : 'Inconnu' }}
        <span class="material-icons-outlined font-14 v-middle pointer" title="Voir le profil utilisateur" (click)="goToUserPage()">visibility</span>
      </h5>
      <div>
        <span> {{ sideBoxItem.user.age }} ans |</span>
        <span class="px-1">{{ displayedCountry }}</span>
        <img class="flag-img" alt="FR" src="https://purecatamphetamine.github.io/country-flag-icons/3x2/{{ sideBoxItem.user['nationality'] }}.svg" *ngIf="sideBoxItem.user['nationality']"/>
      </div>
      <span class="mt-1">{{ sideBoxItem.user && sideBoxItem.user['school'] ? sideBoxItem.user['school'].name : 'Inconnu' }}</span>
      <a href="mailto:{{sideBoxItem.user.email}}" class="lightGray mt-2 w-fit-content" *ngIf="sideBoxItem.user && sideBoxItem.user.email">{{ sideBoxItem.user.email }}</a>
      <span class="lightGray">{{ sideBoxItem.user && sideBoxItem.user.phone ? sideBoxItem.user.phone : '' }}</span>
    </div>
    <div class="status-pastille bg-grad-red d-flex flex-row pxr-1 text-uppercase font-12 w-fit-content mx-auto align-items-center text-white fw-bold" *ngIf="sideBoxItem.status === 'Not-refunded'">
      Remboursement refusé
    </div>
    <div class="status-pastille bg-grad-yellow d-flex flex-row pxr-1 text-uppercase font-12 w-fit-content mx-auto align-items-center text-white fw-bold" *ngIf="sideBoxItem.status === 'Canceled'">
      Remboursement annulé
    </div>
  </div>
  <!-- INFORMATION DU USER -->
  <div class="lf-primary-bg d-flex flex-column mediumGray mt-3 p-3 br-24 overflow-hidden gap-8 fw-bold txt-darkGray">
    <div>
      <span class="fw-light mediumGray">Ville :</span>
      {{ sideBoxItem.user.school && sideBoxItem.user.school.city ? sideBoxItem.user.school.city : 'N/A' }}
    </div>
    <div>
      <span class="fw-light mediumGray">Adresse de résidence :</span>
      {{ sideBoxItem['certificate_datas'] ? sideBoxItem['certificate_datas']['address1'] : 'N/A' }}
    </div>
    <div>
      <span class="fw-light mediumGray">Code postal de résidence :</span>
      {{ sideBoxItem['certificate_datas'] ? sideBoxItem['certificate_datas']['address2'][sideBoxItem['certificate_datas']['address2'].length - 2] : 'N/A'}}
    </div>
    <div>
      <span class="fw-light mediumGray">Ville de résidence :</span>
      {{ sideBoxItem['certificate_datas'] ? sideBoxItem['certificate_datas']['address2'][sideBoxItem['certificate_datas']['address2'].length - 1] : 'N/A'}}
    </div>
    <div>
      <span class="fw-light mediumGray">Pays de résidence :</span>
      France
    </div>
    <div>
      <span class="fw-light mediumGray">Date de naissance :</span>
      {{ sideBoxItem.user['birthdate'] | date:'shortDate':'':'FR' }}
    </div>
    <div>
      <span class="fw-light mediumGray">Ville de naissance :</span>
      {{ sideBoxItem.user.birthplace }}
    </div>
    <div>
      <span class="fw-light mediumGray">Pays de naissance :</span>
      {{ sideBoxItem.user.birthCountry }}
    </div>
    <div>
      <span class="fw-light mediumGray">Nationalité :</span>
      {{ displayedCountry }}
    </div>

  </div>

  <!-- DOCUMENT SI PENDING -->
  <div class="d-flex flex-row align-items-center gap-8 mt-3"
    *ngIf="sideBoxItem.status === 'Pending-refund' || sideBoxItem.status === 'Pending-document' ||
              sideBoxItem.status === 'Refunded' || sideBoxItem.status === 'Not-refunded'">
    <div class="pointer visa_box br-6 d-flex justify-content-center align-items-center"
      title="{{sideBoxItem.user['visaDocument'] ? 'Voir le document dans un nouvel onglet' : 'Document introuvable'}}"
      (click)="goToDocument(sideBoxItem.user['visaDocument'])" [ngClass]="{'noclick' : !sideBoxItem.user['visaDocument']}">
      <span class="material-icons txt-blue-sky">language</span>
    </div>
    <div class="d-flex flex-column w-100">
      <div class="fw-bold font-12">Document de refus de visa</div>
      <div class="lightGray font-10">
        {{ sideBoxItem.user['visaDocument'] && sideBoxItem.user['visaDocument']['pivot'] ? sideBoxItem.user['visaDocument']['pivot'].filename : 'fichier introuvable' }}
      </div>
      <div class="icon_box d-flex flex-row gap-8 ms-auto position-relative">
        <button class="btn btn-success py-0 px-2 font-14 border-0" title="Valider le document" (click)="updateDocumentStatus(sideBoxItem.user['visaDocument'], 'validated', 'Pending-refund')"
          [disabled]="!sideBoxItem.user['visaDocument']" *ngIf="sideBoxItem.status !== 'Refunded' && sideBoxItem.status !== 'Not-refunded'">
          Valider
        </button>
        <button class="btn btn-danger py-0 px-2 font-14 border-0" title="Définir un motif de refus"
          (click)="$event.stopPropagation();
                (sideBoxItem.user['visaDocument'] ? isRefusalOpen = true : updateDocumentStatus(sideBoxItem.user['visaDocument'], 'absent', 'Pending-document'))"
          [disabled]="sideBoxItem.status === 'Pending-document'" *ngIf="sideBoxItem.status !== 'Refunded' && sideBoxItem.status !== 'Not-refunded'">
          Refuser
        </button>
        <mat-icon class="download-icon font-16 lightGray2 d-flex align-items-center justify-content-center pointer"
          title="Voir le document" (click)="goToDocument(sideBoxItem.user['visaDocument'])"
          [ngClass]="{'noclick' : !sideBoxItem.user['visaDocument']}">
          open_in_browser
        </mat-icon>
        <!--   REFUSAL MODAL     -->
        <div class="position-absolute bg-white pt-2 px-3 pb-0 br-16 shadow" *ngIf="isRefusalOpen" (click)="$event.stopPropagation()">
          <p class="font-12">Sélectionnez un motif de refus en cliquant sur un des boutons ou personnalisez-le via le
            formulaire.</p>
          <p class="fw-bold font-12 mb-2">Pensez à valider dans tous les cas.</p>
          <div class="d-flex align-items-center gap-8">
            <button class="btn btn-danger py-0 px-1 font-12" (click)="docRefusalValue = 'unreadable'" title="Définir le document comme illisible">
              Illisible
            </button>
            <button class="btn btn-danger py-0 px-1 font-12" (click)="docRefusalValue = 'incorrect'" title="Définir le document comme incorrect">
              Incorrect
            </button>
            <mat-form-field class="font-12">
              <mat-label>Raison personnalisée</mat-label>
              <input matInput type="text" [(ngModel)]="docRefusalValue">
            </mat-form-field>
            <mat-icon class="bg-primary text-white p-2 d-flex align-items-center justify-content-center pointer"
              (click)="updateDocumentStatus(sideBoxItem.user['visaDocument'], docRefusalValue, 'Pending-document')"
              title="Mettre à jour le statut du document">
              done
            </mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- BOUTONS SI PENDING -->
  <div class="d-flex flex-row align-items-center gap-8 mt-3" *ngIf="sideBoxItem.status === 'Pending-refund' || sideBoxItem.status === 'Pending-document'">
    <!--<button class="btn border-primary border-2 text-primary py-2 flex-grow-1" (click)="makeRefund('Not-refunded')">
      Refuser
    </button>-->
    <mat-form-field>
      <mat-label>Motif du refus</mat-label>
      <mat-select (selectionChange)="makeRefund('Not-refunded', $event)" class="btn border-primary border-2 text-primary py-2 ">
        <mat-option value="WRONG_REASON_5">Motif 5 non-respecté</mat-option>
        <mat-option value="EXPIRED">Attestation périmée</mat-option>
        <mat-option value="FALSE_DOCUMENT">Document faux</mat-option>
      </mat-select>
    </mat-form-field>

    <button class="btn btn-primary py-2 flex-grow-1 d-flex flex-row gap-3 align-items-center justify-content-center"
      [disabled]="!sideBoxItem.user['visaDocument'] || sideBoxItem.status === 'Pending-document' || isPendingRefund"
      (click)="makeRefund('Refunded')">
      Rembourser
      <div class="spinner-border spinner-border-sm text-primary" *ngIf="isPendingRefund"></div>
    </button>
  </div>
</div>
